export default __webpack_public_path__ + "static/media/img-01.976e35f3.jpg";